import { vars } from '@app/config'
import { getCookie } from '@app/services'
import { getAuthMode } from '@app/utils'

import { getActiveAuthTokenFromCookies } from './getActiveAuthTokenFromCookies'
import { getAuthSessionKey } from './getAuthSessionKey'

export const getAuthSessionKeyFromCookies = () => {
  const { buyerTokenMode } = getAuthMode()
  const token = getActiveAuthTokenFromCookies()

  return getAuthSessionKey({
    token,
    urlToken: getCookie(vars.url_token),
    buyerTokenMode,
  })
}
